<template>
  <div
    v-if="page"
    :class="$style.root"
  >
    <PagesEventsSlugHeaderComponent :page="page" />
    <CoreBlocksComponent :blocks="page?.blocks" />
    <SharedRelatedComponent :page="page" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const page = baseStrapiGetAttributes(props.data)

</script>

<style module>
.root {
}
</style>
